import { CalendarDays, CircleUserRound, Landmark, Shield, UsersRound } from "lucide-react";
import { useMemo } from "react";
import { NavLink, Outlet } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

const tabs = [
  { to: "/", icon: CalendarDays, label: "Início", testId: "nav-home" },
  { to: "/jogadores", icon: UsersRound, label: "Jogadores", testId: "nav-players" },
  { to: "/times", icon: Shield, label: "Times", testId: "nav-teams" },
  { to: "/caixa", icon: Landmark, label: "Caixa", testId: "nav-treasury" },
  { to: "/perfil", icon: CircleUserRound, label: "Perfil", testId: "nav-profile" },
];

export default function AppLayout() {
  const { user } = useAuth();
  const outletContext = useMemo(() => ({ user }), [user]);
  return (
    <main className="app-shell" data-testid="app-shell">
      <Outlet context={outletContext} />
      <nav className="bottom-nav" aria-label="Navegação principal" data-testid="bottom-navigation">
        {tabs.map(({ to, icon: Icon, label, testId }) => (
          <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} data-testid={testId}>
            <Icon size={21} strokeWidth={2.2} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      {user?.role === "admin" && <span className="admin-dot" data-testid="admin-session-indicator" />}
    </main>
  );
}
